import React from 'react';
import {HStack, Input, Switch, VStack} from "@chakra-ui/react";
import {useForm} from "@/uses/useForm";
import {useAddField} from "@/uses/useAddField";
import ConditionalForm from "@/components/form/ConditionalForm";
import {useModal} from "@/contexts/modalContext";
import stringUtil from "@/utils/stringUtil";
import {Field, FilesInput, LanguageField} from '@/components';
import {useLanguage} from "@/contexts/languageContext";

export const AddText = ({fields, type}) => {

    const {open, close} = useModal();
    const {getLangObject, t} = useLanguage();
    const {formData, formFieldErrors, handleInputChange, handleFormSubmit} = useForm(
        {
            id: stringUtil.generateAlphanumericHash(8),
            type: type ?? 'text',
            label: getLangObject(),
            images: [],
            required: false,
            conditional: null,
        },
        {
            label: {
                custom: {
                    function: (value) => {
                        return Object.values(value).every((value) => value && value.length >= 3)
                    },
                    message: t('errors.pleaseFillFieldAllLanguages')
                },
            },
        }
    );

    useAddField(handleFormSubmit, formData);

    return (
        <VStack w="100%" flex={1} overflowY="auto" alignItems="stretch" p={4}>
            <VStack alignItems="flex-start" gap="2vh">
                <HStack w="100%" justifyContent="space-between" alignItems="center">
                    <Field
                        label={t('wrappers.nonMandatoryLabel', { value: t('misc.mandatoryField') })}
                        isDisabled={formData?.conditional}
                        display="flex"
                        alignItems="center"
                        mb="2vh"
                    >
                        <Switch.Root
                            size="lg"
                            id={`required-field-${type}`}
                            checked={formData.required}
                            onCheckedChange={(e) => handleInputChange('required', Boolean(e?.checked))}
                        >
                            <Switch.HiddenInput/>
                            <Switch.Control/>
                            <Switch.Label/>
                        </Switch.Root>
                    </Field>
                    <Field
                        label={t('wrappers.nonMandatoryLabel', { value: t('fields.condition') })}
                        display="flex"
                        alignItems="center"
                        isDisabled={formData?.required === true || fields.length === 0}
                        mb="2vh"
                    >
                        <Switch.Root
                            size="lg"
                            id={`required-field-${type}`}
                            checked={formData.conditional !== null}
                            onCheckedChange={(e) => {
                                if (Boolean(e?.checked)) {
                                    open(<ConditionalForm close={() => close('addFormField')}
                                                          onSubmit={(data) => handleInputChange('conditional', data)}
                                                          fields={fields}/>, '3xl', {closeOnOverlayClick: false}, true, 'conditionalModal')
                                } else {
                                    handleInputChange('conditional', null)
                                }
                            }}
                        >
                            <Switch.HiddenInput/>
                            <Switch.Control/>
                            <Switch.Label/>
                        </Switch.Root>
                    </Field>
                </HStack>
                <HStack w="100%" align="flex-start" justify="space-between">
                    <LanguageField
                        id="label"
                        overflow="hidden"
                        errors={formFieldErrors.label}
                        label={t('wrappers.mandatoryLabel', { value: t('fields.label') })}
                        renderElement={(lang) => <Input
                            value={formData.label[lang]}
                            onChange={(e) => handleInputChange('label', (prevData) => ({
                                ...prevData.label,
                                [lang]: e?.target?.value
                            }))}
                            placeholder={t('fields.label')}
                        />}
                    />
                </HStack>
                <Field
                    w="100%"
                    label={t('wrappers.nonMandatoryLabel', { value: t('objects.image_other') })}
                >
                    <FilesInput
                        w="100%"
                        noLabel
                        multiple
                        accept="image/*"
                        files={formData.images ?? []}
                        onChange={(images) => handleInputChange('images', images)}
                    />
                </Field>
            </VStack>
        </VStack>
    );
};

export default AddText;
